"use client";

import React, { createContext, useState, useContext, useMemo } from "react";

interface AppContextType {
  autoPaySelected: boolean | null;
  setAutoPaySelected: (autoPaySelected: boolean | null) => void;
  isOpenCardholderConsentModal: boolean;
  setIsOpenCardholderConsentModal: (
    isOpenCardholderConsentModal: boolean
  ) => void;
  isCardHolder: boolean;
  setIsCardHolder: (isCardHolder: boolean) => void;
  isFuturePayment: boolean;
  setIsFuturePayment: (isFuturePayment: boolean) => void;
}

const RenewalPaymentSummaryStateContext = createContext<AppContextType>({
  autoPaySelected: true,
  setAutoPaySelected: () => {},
  isOpenCardholderConsentModal: false,
  setIsOpenCardholderConsentModal: () => {},
  isCardHolder: false,
  setIsCardHolder: () => {},
  isFuturePayment: false,
  setIsFuturePayment: () => {},
});

type RenewalStateProviderProps = {
  children: React.ReactNode;
};

function RenewalPaymentSummaryStateProvider({
  children,
}: Readonly<RenewalStateProviderProps>) {
  const [autoPaySelected, setAutoPaySelected] = useState<boolean | null>(null);
  const [isOpenCardholderConsentModal, setIsOpenCardholderConsentModal] =
    useState<boolean>(false);
  const [isCardHolder, setIsCardHolder] = React.useState<boolean>(false);
  const [isFuturePayment, setIsFuturePayment] = React.useState<boolean>(false);

  const value = useMemo(
    () => ({
      autoPaySelected,
      setAutoPaySelected,
      isOpenCardholderConsentModal,
      setIsOpenCardholderConsentModal,
      isCardHolder,
      setIsCardHolder,
      isFuturePayment,
      setIsFuturePayment,
    }),
    [
      autoPaySelected,
      isOpenCardholderConsentModal,
      isCardHolder,
      isFuturePayment,
    ]
  );

  return (
    <RenewalPaymentSummaryStateContext.Provider value={value}>
      {children}
    </RenewalPaymentSummaryStateContext.Provider>
  );
}

export const useRenewalPaymentSummaryStateContext = () =>
  useContext(RenewalPaymentSummaryStateContext);

export default RenewalPaymentSummaryStateProvider;
